import { Input, InputRef, Select, Space } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import turbo_icon from 'assets/icons/turbo_icon.png';
import classNames from 'classnames';
import { isValidAmount } from 'features/home/components/Modals/WithdrawModal';
import { selectCurrentTurbo, setCurrentTurbo } from 'features/home/homeSlice';
import useUserDetail from 'hooks/useUserDetail';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { selectTokenPrice } from 'redux/userSlice';

const { Option } = Select;

interface TurboButtonProps {
  classes?: string;
}
const turbos = [
  {
    value: '',
    label: <img src={turbo_icon} alt="turbo" className="dropdown-logo" />,
  },
];

const TurboButton: React.FunctionComponent<TurboButtonProps> = ({ classes = '' }) => {
  const currentTurbo = useAppSelector(selectCurrentTurbo);
  const [customTurbo, setCustomTurbo] = useState<string>('');
  const [items, setItems] = useState<any[]>(turbos);
  const dispatch = useAppDispatch();
  const { currentUser } = useUserDetail();
  const inputRef = useRef<InputRef>(null);
  const selectedTokenPrice = useAppSelector(selectTokenPrice);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^(?!0+$)([1-9]\d{0,3}|10000|0)$/;
    const value = event.target.value;

    if ((regex.test(value) && isValidAmount(value)) || value === '') {
      setCustomTurbo(value);
    }
  };

  const handleChangeTurbo = (value: string) => {
    dispatch(setCurrentTurbo(value));
  };

  // useEffect(() => {
  //   handleChangeTurbo(customTurbo);
  // }, [customTurbo]);

  const addItem = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e.preventDefault();
    if (!customTurbo) return;
    if (items.some((x) => x.value === customTurbo)) return;
    const newItems = [...turbos, { value: customTurbo, label: `${customTurbo}$` }];
    setItems(newItems);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
    handleChangeTurbo(customTurbo);
    setCustomTurbo('');
  };

  const handleEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      dispatch(setCurrentTurbo(event.currentTarget.value));
    }
  };

  const handleBlur = useCallback(
    (event: React.FocusEvent<HTMLElement>) => {
      if (!currentTurbo) {
        dispatch(setCurrentTurbo(customTurbo));
      }
    },
    [customTurbo, currentTurbo],
  );

  const handleRemoveTurbo = () => {
    if (currentTurbo !== '') {
      dispatch(setCurrentTurbo(''));
      setCustomTurbo('');
    }
  };

  return (
    <div
      className={classNames(`turbo ${classes}`)}
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <Select
        className={`turbo-dropdown ${currentTurbo === '' ? 'circle' : 'active'}`}
        dropdownClassName="asset-dropdown primary-text-color"
        value={currentTurbo ? `${currentTurbo} $` : ''}
        onChange={handleChangeTurbo}
        onClick={handleRemoveTurbo}
        onBlur={handleBlur}
        dropdownRender={(turbo) => (
          <>
            <Space style={{ padding: '0 4px 4px', gap: '0' }}>
              <Input
                ref={inputRef}
                type="text"
                name="amount"
                id="amount"
                autoComplete="off"
                onChange={onChange}
                value={customTurbo}
                className="input-turbo"
                onKeyUp={handleEnter}
              />
              <span className="prefix">$</span>
            </Space>
          </>
        )}
        placement="bottomRight"
      >
        {items.map((item) => (
          <Option key={item.value} className="turbo-option-item ">
            {item.value === '' ? (
              <img src={turbo_icon} alt="turbo" className="dropdown-logo" />
            ) : (
              <p>{`${Number(item.value)} $`} </p>
            )}
            <p className={`${item.value === '' ? 'turbo-option-item-none' : null}`}></p>
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default TurboButton;
